var twig = require("twig").twig,
    tokens = [{"type":"raw","value":"<input (input) type=\"datetime-local\">"}],
    template = twig({"id":"$resolved:2ad5e1bf6eb4b8e89f32c96e629eec1c092ec4032646d8491544d8e805838dec8dac8a13b4d860b30c11cbc230e435f723fd33d880ede94429a27cd03634d160:magic-input-datetime.twig","data":[{"type":"raw","value":"<input (input) type=\"datetime-local\">"}],"allowInlineIncludes":true,"rethrow":true});

module.exports = function(context) { return template.render(context); }

module.exports.tokens = tokens;